import { useSurfacePreference } from "../../../hooks/use-surface-preference.ts"
import { surfaceKey } from "../../User/redux/ui-preferences.types.ts"

export type AlbumsView = "grid" | "list"

export const ALBUMS_VIEW_PREFERENCE_KEY = surfaceKey("project.albums.view")

export const DEFAULT_ALBUMS_VIEW: AlbumsView = "grid"

export const useAlbumsView = (): [
  AlbumsView,
  (view: AlbumsView | null) => void
] =>
  useSurfacePreference<AlbumsView>(
    ALBUMS_VIEW_PREFERENCE_KEY,
    DEFAULT_ALBUMS_VIEW
  )
